import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { margin, padding } from '@mui/system';

export const useStyles = makeStyles((theme: Theme) => ({
  AnnouncementContainer: {
    background: theme.palette.KenColors.kenWhite,
    padding: '20px 20px',
    boxShadow: 'none !important',
    height: '83.5vh',
    borderRadius: '9px !important',
    [theme.breakpoints.down('md')]: {
      padding: '10px 10px',
      minHeight: '100% !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '81vh !important',
    },
  },
  groupsContainerTitle: {
    fontSize: '15px !important',
    fontWeight: '500 !important',
    textAlign: 'start',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12.5px !important',
    },
  },

  postContainer: {
    paddingTop: '10px',
    height: '70vh',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '63.2vh',
    },
  },
  postContainer1: {
    paddingTop: '10px',
    height: '68.5vh',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '61.2vh',
    },
  },
  avatar: {
    width: '36px !important',
    height: '36px !important',
    color: theme.palette.KenColors.ClientBlue7,
    backgroundColor: theme.palette.KenColors.WhiteGray4,
  },

  DiscoverGroupContainer: {
    background: theme.palette.KenColors.kenWhite,
    padding: '20px 20px',
    boxShadow: 'none !important',
    borderRadius: '9px !important',

    [theme.breakpoints.down('md')]: {
      padding: '0px 20px 20px 20px !important',
      marginTop: '50px',
    },
    '@media (max-width:626px)': {
     marginTop: '0px',
     padding: '0px 10px 10px 10px !important',

    },
  },
  DiscoverGroupContainerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '20px',
    '@media (max-width:626px)': {
      paddingTop: '10px',
     },
  },
  links: {
    color: '#373A45 !important',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    borderRadius : '8px',
    border : '1px solid #D9DBE1',
    gap: '10px',
    cursor: 'pointer',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '11.5px !important',
    },
  },

  // create-group
  cardContainerForm: {
    boxShadow: 'none !important',
    textAlign: 'start',
    borderRadius: '16px !important',
    padding: '20px',
  },
  pageHeader: {
    fontSize: '15px !important',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientBlack2,
    padding: '10px 0px 10px 0px !important',
    lineHeight: '28px',
  },
  gridContainer: {
    height: '63vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '54vh',
    },
  },
  formFooter: {
    display: 'flex',
    justifyContent: 'end',
    gap: '20px',
    borderTop: `1px solid ${theme.palette.KenColors.ClientDivider}`,
    paddingTop: '20px',
  },

  // group-details

  paperCustom: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    textAlign: 'start',
    padding: '20px',
    borderRadius: '16px !important',
    width: '100%',
    height: '83.5vh',
    [theme.breakpoints.down('md')]: {
      width: '94%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '94%',
    },
  },

  eventBanner: {
    height: '230px !important',
    width: '100% !important',
    borderRadius: '10px !important',
  },
  groupTagContainer: { display: 'flex', alignItems: 'center', justifyContent: 'start', gap: '10px !important' },

  filterCellsContainer: {
    display: 'flex',
    padding: '10px 20px',
    alignItems: 'center',
    gap: '6px',
    borderRadius: '20px !important',
    background: `${theme.palette.KenColors.ClientBlue4} !important`,
    boxShadow: 'none !important',
    [theme.breakpoints.down('md')]: {
      padding: '5px 10px',
      gap: '3px',
    },
  },
  filterCellsContainerTypo: {
    color: theme.palette.KenColors.ClientBlue5,
    fontWeight: '500 !important',
    whiteSpace: 'nowrap',
    fontSize: '12px',
  },

  boxContainer1: {
    marginBlock: '10px !important',
  },
  aboutTheGroupContainerHeaderTypo: {
    fontSize: '12px !important',
    fontWeight: '600 !important',
    lineHeight: '22px !important',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px !important',
    },
  },
  subTypo: {
    fontSize: '12px !important',
    fontWeight: '400 !important',
    lineHeight: '22px !important',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px !important',
    },
  },
  boxContainer2: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '10px !important',
  },
  boxContainer3: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px !important',
    gap: '10px !important',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start',
      gap: '20px !important',
    },
  },
  boxContainer4: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '40px !important',
  },
  activeTypo: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    lineHeight: '22px !important',
  },
  activityContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '5px',
  },
  joinedGroupContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px !important',
    justifyContent: 'end',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'space-between',
    },
  },
  appButtonMessage: {
    fontSize: '16px !important',
    paddingInline: '40px !important',
    backgroundColor: `${theme.palette.KenColors.ClientPrimaryGrey} !important`,
    color: `${theme.palette.KenColors.ClientBlack2} !important`,
    '&:hover': {
      backgroundColor: `${theme.palette.KenColors.ClientPrimaryGrey} !important`,
      color: `${theme.palette.KenColors.ClientBlack2} !important`,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
      paddingInline: '30px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      paddingInline: '20px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      paddingInline: '10px !important',
    },
  },
  appButtonLeave: {
    fontSize: '16px !important',
    paddingInline: '40px !important',
    backgroundColor: `${theme.palette.KenColors.ClientRed2} !important`,
    color: `${theme.palette.KenColors.ClientRed} !important`,
    '&:hover': {
      backgroundColor: `${theme.palette.KenColors.ClientRed2} !important`,
      color: `${theme.palette.KenColors.ClientRed} !important`,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
      paddingInline: '30px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      paddingInline: '20px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      paddingInline: '10px !important',
    },
  },
  customPositiveButtonStyle: {
    fontSize: '16px !important',
    paddingInline: '40px !important',
    backgroundColor: `${theme.palette.KenColors.ClientRed2} !important`,
    color: `${theme.palette.KenColors.ClientRed} !important`,
    '&:hover': {
      backgroundColor: `${theme.palette.KenColors.ClientRed2} !important`,
      color: `${theme.palette.KenColors.ClientRed} !important`,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
      paddingInline: '30px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      paddingInline: '20px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      paddingInline: '10px !important',
    },
  },
}));
